<script src="//cdnjs.cloudflare.com/ajax/libs/blueimp-md5/2.10.0/js/md5.min.js"></script>
<template>
  <v-container style="padding: 0" class="content-container" fluid>
    
    <div class="wallet-title">
      <!-- <img src="@/assets/img/logo.svg" style="width: 12rem" /> -->
      <img :src="imgSrcLogo()" style="width: 12rem" />

      

      <!-- <v-menu offset-y v-if="localeShow">
          <template v-slot:activator="{ on, attrs, value }">
            <v-btn
              color="#323232"
              text
              v-bind="attrs"
              v-on="on"
              width="6rem"
              class="px-0 pl-2"
            >
              <div
                class="d-flex justify-space-between align-center"
                style="width:100%;"
              >
                <div>{{ currentLocale.label }}</div>
                <v-icon v-bind:class="{ rotate180: value }"
                  >mdi-menu-down</v-icon
                >
              </div>
            </v-btn>
          </template>
          <v-list class="locale-menu">
            <v-list-item
              v-for="(item, index) in availableLocales"
              :key="index"
              @click="onClickItem(item.code)"
            >
              <v-list-item-title>{{ item.label }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu> -->
      <template v-if="activeHIconMenu === false ">
      <!-- <template v-if="activeMenu === 'pay'"> -->
        
        <v-btn
                icon
                style="position: fixed; right: 1rem"
                href="/#/buy"
              >     
                <v-icon color="#121212">mdi-camera mdi-34px</v-icon>
                <!-- <v-icon color="#121212">mdi-qrcode-scan mdi-34px</v-icon> -->
                <!-- <v-icon color="#013e79" width="100px;">mdi-wallet mdi-36px</v-icon> -->
             </v-btn> 
      </template>
      
      <template v-if="activeHIconMenu === true ">      
      <!-- <template v-if="activeMenu !== 'pay'">       -->
          <v-dialog        
            v-model="dialog"
            max-width="20rem"
            transition="dialog-bottom-transition"
          >
            
            <template v-slot:activator="{ on, attrs }" >   <!-- v-if="activeMenu !== 'pay'"  -->
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                style="position: fixed; right: 1rem"
              >
              
                <!-- <v-icon color="#121212">mdi-qrcode-scan mdi-36px </v-icon> -->
                <v-icon color="#121212" width="100px;">mdi-ticket-account  mdi-36px</v-icon>
              </v-btn>
            
            </template> 
    


            <template v-slot:default="dialog">
              <v-card class="">
                <v-card-title class="dialog-title">
                  <span class="text-subtitle-2 font-weight-bold">
                    {{ $t('home.myWalletAddress') }}
                  </span>
          <v-col
            cols="2"
            sm="4"
            md="4"
            style=" position: relative;    top: -10px;"
          >
            <v-switch
              v-model="is_network"
              label=""
              color="red"
              value="trx"
              hide-details
            >ss</v-switch>
            
          </v-col>
                </v-card-title>
                <v-card-text class="text-center px-0">
                  <vue-q-r-code-component
                    :size="200"
                    :text="myWalletAdress"
                    class="qr-code"
                  />

                  <div class="text-caption mt-4">{{ myWalletAdress }}</div>
                  <input
                    type="hidden"
                    id="my-wallet-adress"
                    :value="myWalletAdress"
                  />
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="ma-0 pa-0" style="width: 100%">
                  <v-btn
                    color="#ADADAD"
                    width="40%"
                    text
                    x-large
                    @click="dialog.value = false"
                    class="font-weight-bold rounded-lb"
                  >
                    {{ $t('close') }}
                  </v-btn>
                  <v-divider vertical></v-divider>
                  <v-btn
                    class="font-weight-bold rounded-rb"
                    color="primary"
                    text
                    width="60%"
                    x-large
                    @click.stop.prevent="copyCode"
                  >
                    <v-icon style="margin-right: 0.5rem">mdi-content-copy</v-icon>
                    <span>{{ $t('home.copyClipboard') }}</span>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
      </template>
    </div>
    <slot></slot>
    <!-- 풋터 -->
    <v-bottom-navigation
      fixed
      :value="activeMenu"
      grow
      color="primary"
      style="background: #fff"
    >
      <v-btn color="white" height="inherit" value="send" @click="sendClick">
        <span class="menu-label">SEND</span>
        <v-icon :color="activeMenu === 'send' ? 'primary' : '#121212'"
          >mdi-send</v-icon
        >
      </v-btn>

      <!-- <v-btn
        color="white"
        height="inherit"
        value="staff"
        @click="staffClick"
        v-show="is_staff"
      >
        <span class="menu-label">BILL</span>
        <v-icon :color="activeMenu === 'staff' ? 'primary' : '#121212'"
          >mdi-circle-multiple</v-icon
        >
      </v-btn> -->

      <v-btn
        color="white"
        height="inherit"
        value="staking"
        @click="stakingClick"
        v-show="!is_staff"
      >
        <span class="menu-label">STAKING</span>
        <v-icon :color="activeMenu === 'staking' ? 'primary' : '#121212'"
          >mdi-circle-multiple</v-icon
        >
      </v-btn>
    

       <!-- Master card  -->
      <v-btn
          color="white"
          height="inherit"
          value="cards"
          @click="masterClick"
        >
        <span class="menu-label">Master</span>
        <v-icon :color="activeMenu === 'cards' ? 'primary' : '#121212'"
          >mdi-card-account-details</v-icon
        >
      </v-btn>

    <!-- 검수용 제외 -->  
      <!-- <v-btn
          color="white"
          height="inherit"
          value="staking"
          @click="nftClick"
        >
        <span class="menu-label">NFT</span>
        <v-icon :color="activeMenu === 'nft' ? 'primary' : '#121212'"
          >mdi-circle-multiple</v-icon
        >
      </v-btn>
     -->

      <v-btn
        color="white"
        height="inherit"
        value="event"
        @click="eventClick"
        v-if="isEvent"
      >
        <span class="menu-label">EVENT</span>
        <v-icon :color="activeMenu === 'event' ? 'primary' : '#121212'"
          >mdi-calendar-check</v-icon
        >
      </v-btn>

      <v-btn color="white" height="inherit" value="home" @click="homeClick">
        <span class="menu-label">HOME</span>
        <v-icon :color="activeMenu === 'home' ? 'primary' : '#121212'"
          >mdi-home</v-icon
        >
      </v-btn>

      <!-- <v-btn color="white" height="inherit" value="swap" @click="swapClick">
        <span class="menu-label">SWAP</span>
        <v-icon :color="activeMenu === 'swap' ? 'primary' : '#121212'"
          >mdi-swap-vertical</v-icon
        >
      </v-btn> -->
      <v-btn color="white" height="inherit" value="pay" @click="payClick">
        <span class="menu-label">PAY</span>
        <v-icon :color="activeMenu === 'pay' ? 'primary' : '#121212'"
          >mdi-barcode-scan</v-icon
        >
      </v-btn>

      <v-btn color="white" height="inherit" value="config" @click="configClick">
        <span class="menu-label">CONFIG</span>
        <v-icon :color="activeMenu === 'config' ? 'primary' : '#121212'"
          >mdi-cog</v-icon
        >
      </v-btn>
    </v-bottom-navigation>
  </v-container>
</template>

<script>
import VueQRCodeComponent from 'vue-qrcode-component'

export default {
  components: { VueQRCodeComponent },
  data() {
    return {
      is_network: null , 
      dialog: false , 
      wlabels:{}
    }
  },
  created(){
    this.$store.commit('wlabel')
    this.wlabels = this.wlabel
  },
  computed: {
    is_staff() {
      
      return this.$store.getters.staff
    },

    is_login() {
      return this.$store.getters.is_login
    },
    loading() {
      return this.$store.getters.loading
    },
    toast() {
      return this.$store.getters.toast
    },
    modal() {
      return this.$store.getters.modal
    },
    wlabel() {
      return this.$store.getters.wlabel
    },
    activeHIconMenu() {
      /**
       * true  : 지갑주소 팝업 
       * false : 스캐너 링크 
       */
       console.log( "activeHIconMenu :: " , this.$store.getters.activeMenu  ,  this.$store.getters.staff )  ; 


      if( this.$store.getters.activeMenu === 'pay' ) {
        // console.log( "activeHIconMenu :: " ,  this.$store.getters.staff )  ; 
        if( this.$store.getters.staff === true  ) {
          return true  ; 
        }else{
          return false  ; 
        } ; 

      }else{
        return true ; 
      }
      
    },    
    activeMenu() {
      
      return this.$store.getters.activeMenu
    },
    myWalletAdress() {
      console.error( this.is_network  )
      return  (this.is_network == null ) ? this.$store.getters.user.wallet_address :this.$store.getters.user.wallet_address_tron  ;
    },
    currentLocale() {
      return this.$i18n.locales.find((i) => i.code === this.$i18n.locale)
    },
    availableLocales() {
      return this.$i18n.locales
    },
    localeShow() {
      return this.$store.getters.activeMenu === 'home'
    },
    isEvent() {
      return (
        this.$store.getters.user.is_event === 'y' ||
        this.$store.getters.user.is_event === 'Y'
      )
    }
  },
  methods: {
    imgSrcLogo() {
      return require(`@/assets/img/${this.wlabels.logo}` ); 
    } , 
    logout() {
      this.$store.commit('is_login', false)
      this.$router.push('/')
    },
    homeClick() {
      if (this.$route.path !== '/home') {
        this.$router.push('/home')
        this.$store.commit('activeMenu', 'home')
      }
    },
    lottoClick() {
      if (this.$route.path !== '/lotto') {
        this.$router.push('/lotto')
        this.$store.commit('activeMenu', 'lotto')
      }
    },

    payClick() {
      if (this.$route.path !== '/pay') {
        this.$router.push('/pay')
        this.$store.commit('activeMenu', 'pay')
      }
    },
    masterClick() {
      console.log( this.$route.path )

      if (this.$route.path !== '/cards') {
        this.$router.push('/cards')
        this.$store.commit('activeMenu', 'cards')
      } 

    } , 
    nftClick() {
      if (this.$route.path !== '/nft') {
        this.$router.push('/nft')
        this.$store.commit('activeMenu', 'nft')
      }      
    } ,     
    sendClick() {
      if (this.$route.path !== '/send') {
        this.$router.push('/send')
        this.$store.commit('activeMenu', 'send')
      }
    },
    staffClick() {
      
      if (this.$route.path !== '/staff') {
        console.log( this.$store.state.user )
        if ( this.$store.state.user.is_admin >0 ){
          this.$router.push('/staff')
          this.$store.commit('activeMenu', 'staff')
        } else if( this.$store.state.user.is_bill > 0  ){
          this.$router.push('/staff')
          this.$store.commit('activeMenu', 'staff')
        }else{            
          
          alert( this.$store.state.user.is_bill >= 1 ? '관리자 승인전입니다. 운영자에게 문의해 주세요' : '사용승인 전입니다. 추천인에게 문의해 주세요' ) ; 
        } ; 
      }
    }, 
    stakingClick() {
      if (this.$route.path !== '/staking') {

        

        this.$router.push('/staking')
        this.$store.commit('activeMenu', 'staking')
      }
    },
    configClick() {
      if (this.$route.path !== '/config') {
        this.$router.push('/config')
        this.$store.commit('activeMenu', 'config')
      }
    },
    swapClick() {
      if (this.$route.path !== '/swap') {
        this.$router.push('/swap')
        this.$store.commit('activeMenu', 'swap')
      }
    },
    eventClick() {
      if (this.$route.path !== '/event') {
        this.$router.push('/event')
        this.$store.commit('activeMenu', 'event')
      }
    },
    copyCode() {
      let codeToCopy = document.querySelector('#my-wallet-adress')
      codeToCopy.setAttribute('type', 'text')
      codeToCopy.select()

      try {
        var successful = document.execCommand('copy')

        if (successful) {
          this.$store.dispatch('toast', {
            toast: true,
            toast_msg: this.$t('home.copySuccess'),
            timeout: 2000
          })
        } else throw new Error('fail')

        this.dialog = false
      } catch (err) {
        this.$store.dispatch('toast', {
          toast: true,
          toast_msg: this.$t('home.copyFail'),
          timeout: 2000
        })
      }

      codeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    onClickItem(code) {
      if (this.$i18n.locale !== code) {
        this.$i18n.locale = code
      }

      if (typeof window.androidBridge != 'undefined') {
        window.androidBridge.bridge_set_lang(code)
      }
      if (typeof window.webkit != 'undefined') {
        window.webkit.messageHandlers.set_lang.postMessage({
          lang: code
        })
      }
      // this.$cookies.set('locale', code, '365d')
      localStorage.locale = code
    }
  }
}
</script>

<style lang="scss" scoped>
.rotate180 {
  transform: rotate(180deg);
}
.dialog-title {
  display: flex;
  justify-content: space-between;
}
.wallet-title {
  width: 100%;
  min-height: 4.8rem;
  height: 80px;
  color: #121212;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.menu-label {
  margin-top: 0.1rem;
  letter-spacing: -0.05px;
  font-size: 0.6rem;
}
</style>
